import React from "react";
import "./PGAModelBuilderModelPlayers.css";
import { graphql, useLazyLoadQuery } from "react-relay";
import StatTable from "../../../../../StatTable";

const GET_PLAYERS = graphql`
  query PGAModelBuilderModelPlayersQuery($modelID: ID!) {
    playersMatchingPgaModel(modelId: $modelID) {
      player {
        fullName
      }

      numRounds
    }
  }
`;

export default function PGAModelBuilderModelPlayers(props) {
  const data = useLazyLoadQuery(
    GET_PLAYERS,
    { modelID: props.modelID },
    { fetchPolicy: "network-only", fetchKey: props.inputReloads }
  );

  const columns = [
    {
      Header: "Player",
      accessor: "playerName",
    },
    {
      Header: "Num Rounds",
      accessor: "numRounds",
    },
  ];

  const tableData = React.useMemo(
    () =>
      data.playersMatchingPgaModel.map((playerMatch) => {
        return {
          playerName: playerMatch.player.fullName,
          numRounds: playerMatch.numRounds,
        };
      }),
    [props.inputReloads]
  );

  return (
    <div className="pga-model-builder-field-container">
      <StatTable columns={columns} data={tableData} />{" "}
    </div>
  );
}
